<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext">
      <div class="container">
        <div class="area_wrap">
          <div class="text_wrap pt-50">
            <p>카톡 상담은 수술 직후 환자 관리를 위한 것으로 </p>
            <p>상담 링크는 수술 후 1개월 동안만 활성화됩니다. </p>
            <p>이후 온라인 상담은 네이버 카페 상담 게시판을 </p>
            <p>이용해 주시기 바랍니다. </p>
            <p>감사합니다.</p>
          </div>
        </div>
      </div>
      <div class="btnWrap" :class="{visible : urlFlag}">
        <button type="button" class="callTerms" @click.prevent="goUrl()">카톡 상담 바로가기</button>
      </div>
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet"/>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import AddPopup from '@/components/AddPopup'
import errorParser from '@/utils/error-parser'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single'
      },
      transDate: {
        headerName: '수술 후 카톡상담',
        prevUrl: '/'
      },
      urlFlag: false,
      setCount: false
    }
  },
  created () {
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
    this.fetchData()
  },
  computed: {
    ...mapGetters([
      'getKakaoUrl'
    ]),
    ...mapState([
      'checkPopup'
    ])
  },
  methods: {
    ...mapMutations([
      'SET_POPUP'
    ]),
    ...mapActions([
      'KAKAO_URL'
    ]),
    callPrev () {
      if (this.setCount) {
        this.$router.push('/')
      } else {
        history.go(1)
      }
      this.setCount = true
      // 클로즈 함수 구현
    },
    async fetchData () {
      try {
        await this.KAKAO_URL()
          .then(() => {
            if (this.getKakaoUrl !== null) {
              this.urlFlag = true
            }
          })
      } catch (error) {
        this.SET_POPUP(true)
        console.log('error :', error);
        console.log('카카오 url api에서 에러발생')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      } finally {

      }
    },
    goUrl () {
      const btn = document.querySelector('.callTerms')
      const url = this.getKakaoUrl
      console.log('url: ', url)
      if (url === null) {
        btn.disabled = 'disabled'
      } else {
        btn.disabled = ''
        location.href = url
      }
    }
  },
  components: {
    AppHeader,
    AppSidebar,
    AddPopup
  },
  beforeDestroy () {
    this.SET_POPUP(false)
    this.setCount = false
  }
}
</script>

<style lang="scss" scoped>
</style>
